module.exports = __webpack_public_path__ + "static/media/5040.84ff2f15.jpg";